import { KMLOptions } from "./data-create-hotspots-kml"
import { createPlacemark, PlacemarkBuilder } from "./hotspotsToKML"

const IntterraPlacemarkBuilder = (options: KMLOptions): PlacemarkBuilder => ({
    build: (id, point) => createPlacemark(id, point, { styleId: "ars-layer", ...options }),
    buildStyle: () => `
<Style id="ars-layer">
    <LineStyle>
        <color>bfcc7f00</color>
        <gx:outerColor>0</gx:outerColor>
        <width>5</width>
    </LineStyle>
    <PolyStyle>
        <color>bfcc7f00</color>
        <fill>0</fill>
        <gx:outerColor>0</gx:outerColor>
    </PolyStyle>
    <IconStyle>
        <colorMode>normal</colorMode>
        <Icon>
            <href>https://cdn.intterra.io/public/icons/isolated-heat.png</href>
        </Icon>
    </IconStyle>
</Style>`,
})

export { IntterraPlacemarkBuilder }
